/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Stream from 'flarum/common/utils/Stream';
import AchievementCategoryName from './AchievementCategoryName';
import AchievementCategoryDesc from './AchievementCategoryDesc';
import AchievementCategoryToggle from './AchievementCategoryToggle';

export default class AchievementCategory extends Component {
	oninit(vnode) {
		super.oninit(vnode);
		this.collapsed = new Stream(false);
	}

	view(vnode) {
		const { category, headerChildren } = this.attrs;

		return (
			<div className="AchievementCategory">
				<div className="AchievementCategoryHeader">
					<AchievementCategoryToggle collapsed={this.collapsed} />
					<AchievementCategoryName category={category} collapsed={this.collapsed} />

					{headerChildren}

					{!this.collapsed() && <AchievementCategoryDesc category={category} />}
				</div>

				{!this.collapsed() && vnode.children}
			</div>
		);
	}
}
